import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  pick(event) {
    const option = event.currentTarget.innerText.trim()
    console.log(`You've picked ${option}.`)
    event.preventDefault()
  }
}
